var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-upload",
        {
          ref: "el-upload",
          staticClass: "avatar-uploader",
          attrs: {
            "before-upload": _vm.beforeAvatarUpload,
            "http-request": _vm.uploadFile,
            "on-preview": _vm.handlePictureCardPreview,
            "on-remove": _vm.handleRemove,
            "on-exceed": _vm.handleExceed,
            "list-type": "picture-card",
            "file-list": _vm.imgList,
            disabled: _vm.disabled,
            action: "#",
            limit: _vm.limit,
          },
        },
        [_c("i", { staticClass: "el-icon-plus" })]
      ),
      _c(
        "el-dialog",
        {
          attrs: { "append-to-body": "", visible: _vm.dialogVisible },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("img", {
            attrs: { width: "100%", src: _vm.dialogImageUrl, alt: "" },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }